export function sendNotification(title, options = {}) {
  if (Notification.permission === 'granted') {
    return Promise.resolve(new Notification(title, options));
  } else if (Notification.permission !== 'granted') {
    Notification.requestPermission().then(function (permission) {
      if (permission === 'granted') {
        return new Notification(title, options);
      }

      return Promise.reject(new Error('No notification allowed'));
    });
  }
}
